
export interface BusinessInfo {
  name: string;
  address: string; // Street Address
  city: string;
  state: string;
  zip: string;
  phone: string;
  email: string;
  website?: string;
}

export interface OwnerInfo {
  name: string; // Full Name
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
}

export interface SeoSection {
  title: string;
  content: string;
}

export interface SeoContent {
  titles: string[];
  sections: SeoSection[];
}

export enum TaskPackage {
  PRO = 'Pro',
  PREMIUM = 'Premium',
  ELITE = 'Elite',
  SUPREME = 'Supreme',
}

export interface ExtractedData {
  businessInfo: BusinessInfo;
  ownerInfo: OwnerInfo;
  agentName: string;
  businessType: string; // e.g., "Nail Salon", "Restaurant"
  seoContent?: SeoContent;
  pdfData?: string[]; // Array of Base64 representations of the uploaded PDFs
  package?: TaskPackage;
}

export interface TaskTemplate {
  id: string;
  name: string;
  notes: string;
  packages: TaskPackage[];
}

export interface AsanaConfig {
  pat: string;
  workspaceId: string;
  projectId?: string;
}

export enum AppStep {
  UPLOAD = 'UPLOAD',
  REVIEW = 'REVIEW',
  ACTIONS = 'ACTIONS',
}

export interface AsanaTask {
  name: string;
  notes: string;
}
